import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';

/** Inject With Credentials into the request */
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

     //console.log("interceptor: " + req.url);
    const cloneConfig: any = {
      withCredentials: true
    };

    if (this.deveIgnorarServiceWorker(req)) {
      cloneConfig.setParams = {
        'ngsw-bypass': 'true'
      };
    }

    req = req.clone(cloneConfig);

    return next.handle(req);
  }

  private deveIgnorarServiceWorker(req: HttpRequest<any>): boolean {
    if (req.method !== 'GET' || req.urlWithParams.includes('ngsw-bypass')) {
      return false;
    }

    if (/^https?:\/\//i.test(req.url) || req.url.startsWith('assets/') || req.url.startsWith('/assets/')) {
      return false;
    }

    return !/\.(css|js|map|svg|png|jpg|jpeg|webp|gif|ico|woff2?|ttf|otf|eot|json|html)(\?|$)/i.test(req.url);
  }
}
